import requests from '@/utils/requests';

/**
 * 创建文档
 * @param {*} data
 */
export function getUserWorkInfo(data) {
  return requests({
    serviceName: 'data-center',
    url: '/datacenter/common/getUserWorkInfo',
    method: 'post',
    data
  });
}
